import type { NavigationGuardNext } from 'vue-router'

type MiddlewareContext = {
  next: NavigationGuardNext
  [key: string]: unknown
}

type MiddlewareFn = (context: MiddlewareContext) => void

const nextFactory = (context: MiddlewareContext, middleware: MiddlewareFn[], index: number): NavigationGuardNext => {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next
  return (...parameters: Parameters<NavigationGuardNext>) => {
    context.next(...parameters as [])
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

export default nextFactory
